<template>
    <button class="goTop" v-if="isVisible" @click="backToTop">
        <i class="fa fa-angle-up" aria-hidden="true"></i>
    </button>
</template>

<script>
    export default {
        name: 'BackToTop',
        data() {
            return {
                isVisible: false
            }
        },
        methods: {
            initToTopButton: function() {
                let self = this;
				$(document).bind('scroll', function() {
					var backToTopButton = $('.goTop');
					if ($(document).scrollTop() > 250) {
                        backToTopButton.addClass('isVisible');
                        self.isVisible = true;
                    } 
                    else {
                        backToTopButton.removeClass('isVisible');
                        self.isVisible = false;
					}
				}.bind(self));
			},
			backToTop: function() {
				$('html,body').stop().animate({
					scrollTop: 0
				}, 'slow', 'swing');
			}
        },
        mounted() {
            this.$nextTick(function() {
                this.initToTopButton();
            });
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/BackToTop.vue